import script from "./ScreenRecorder.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenRecorder.vue?vue&type=script&setup=true&lang=js"

import "./ScreenRecorder.vue?vue&type=style&index=0&id=a8161004&lang=scss"

const __exports__ = script;

export default __exports__